// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  // apiServiceBaseUri: window['env']['apiServiceBaseUri'] || 'https://player.rfbrandmusic.com.br/api/',
  // apiServiceBaseUri: window['env']['apiServiceBaseUri'] || 'https://rfplayer-us.azurewebsites.net/api/',
  // azureBlobStorage: window['env']['azureBlobStorage'] || 'https://rfplayerus.blob.core.windows.net/',
  // azureBlobQueue: window['env']['azureBlobQueue'] || 'https://rfplayerus.queue.core.windows.net/'
  apiServiceBaseUri: window['env']['apiServiceBaseUri'] || 'https://player.rfbrandmusic.com.br/api/',
  azureBlobStorage: window['env']['azureBlobStorage'] || 'https://rfplayer.blob.core.windows.net/',
  azureBlobQueue: window['env']['azureBlobQueue'] || 'https://rfplayer.queue.core.windows.net:443/'
};
